export default {
  initialized: true,
  globalFilters: {
    // contractingPeriod: {
    //   key: 'contractingPeriod',
    //   // title: 'Contracting Period',
    //   // type: 'list',
    //   // value: [{ startDate: '2019-04-01T00:00:00.000Z', endDate: '2020-03-31T00:00:00.000Z' }],
    //   title: 'Contract Period contains:',
    //   type: 'contractingPeriod',
    //   selectedValue: '',
    // },
    dateRange: {
      key: 'dateRange',
      isCustomRange: false,
      selectedValue: '',
      type: 'date',
      dateChoices: [
        { title: 'This Week', timeValue: 'week', timeVar: 0 },
        { title: 'Last Week', timeValue: 'week', timeVar: -1 },
        { title: 'This Month', timeValue: 'month', timeVar: 0 },
        { title: 'Last Month', timeValue: 'month', timeVar: -1 },
        { title: 'This Quarter', timeValue: 'quarter', timeVar: 0 },
        { title: 'Last Quarter', timeValue: 'quarter', timeVar: -1 },
      ],
    },
    folder: {
      key: 'folder',
      title: 'Folder',
      type: 'list',
      list: [],
    },
    locations: {
      key: 'locations',
      title: 'Locations',
      type: 'list',
      list: [],
    }
  },
  items: [
    {
      id: 1,
      chart: 'ContractFunnel',
      error: false,
      isLoading: true,
      lastSync: null,
      name: 'Contracting Progress Funnel',
      size: [3, 3],
      url: '/analytics/contracts',
      x: 1,
      y: 1,
    },
    {
      id: 2,
      chart: 'ContractTaskList',
      data: {},
      error: false,
      isLoading: true,
      lastSync: null,
      name: 'Contracting Task List',
      size: [3, 2],
      url: '/analytics/contracts/tasks',
      x: 2,
      y: 1,
    },
    {
      id: 3,
      chart: 'SentItems',
      error: false,
      isLoading: true,
      lastSync: null,
      name: 'Tracking for Sent Rates',
      size: [3, 2.5],
      url: '/analytics/sentItems',
      x: 4,
      y: 1,
    },
    {
      id: 4,
      chart: 'ContractActivityStats',
      error: false,
      isLoading: true,
      lastSync: null,
      name: 'Productivity',
      size: [2, 2],
      url: '/analytics/contracts/activity',
      x: 1,
      y: 2,
    },
    {
      id: 5,
      chart: 'PotentialPartners',
      error: false,
      isLoading: true,
      lastSync: null,
      name: 'Sales Opportunities',
      size: [2, 1.5],
      url: '/analytics/contracts/potentialPartners',
      x: 1,
      y: 2,
    },
    {
      id: 6,
      chart: 'ContractActivityFeed', // combined ContractActivityStats with the feed
      error: false,
      filters: {}, // { userId: { filterBy: 'userId', filterItems: [], filterValue: '' }, days: { filterBy: 'days', filterItems: [], filterValue: '' } }
      isLoading: true,
      lastSync: null,
      name: `Your Partners' Activities`,
      size: [2, 4],
      url: '/analytics/contracts/feed',
      x: 3,
      y: 2,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/app/components/contracting-dashboard/__storeFiles__/supplier-initial-state.js